import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import LazyHydration from 'components/LazyHydration';

const OffersCarousel = dynamic(() => import('.'));

const DynamicallyLoadedOffersCarousel = ({
  gaEventCategory,
  relatedOffers,
  threadId,
}) => (
  <LazyHydration placeholderSize={{ height: 296 }}>
    <OffersCarousel
      gaEventCategory={gaEventCategory}
      relatedOffers={relatedOffers}
      threadId={threadId}
    />
  </LazyHydration>
);

DynamicallyLoadedOffersCarousel.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  relatedOffers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  threadId: PropTypes.number.isRequired,
};

export default DynamicallyLoadedOffersCarousel;
